import React from 'react';

export const DatasetVersionSelect: React.FC<{
  datasets: string[];
  selectedDataset: string;
  onDatasetChange: (dataset: string) => void;
  versions: string[];
  selectedVersion: string;
  onVersionChange: (version: string) => void;
}> = ({
  datasets,
  selectedDataset,
  onDatasetChange,
  versions,
  selectedVersion,
  onVersionChange,
}) => (
  <>
    <div className="dvc-form-group">
      <label htmlFor="datasetSelect">Dataset:</label>
      <select
        id="datasetSelect"
        value={selectedDataset}
        onChange={(e) => onDatasetChange(e.target.value)}
        className="dvc-select"
      >
        <option value="">Select a dataset...</option>
        {datasets.map((dataset) => (
          <option key={dataset} value={dataset}>
            {dataset}
          </option>
        ))}
      </select>
    </div>
    {selectedDataset && (
      <div className="dvc-form-group">
        <label htmlFor="versionSelect">Version:</label>
        <select
          id="versionSelect"
          value={selectedVersion}
          onChange={(e) => onVersionChange(e.target.value)}
          className="dvc-select"
        >
          <option value="">Select a version...</option>
          {versions.map((version) => (
            <option key={version} value={version}>
              {version}
            </option>
          ))}
        </select>
      </div>
    )}
  </>
);
